"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pieve-a-nievole": {
    "f94c48a5": [{
      "hkey": "c577d92f",
      "slug": "pieve-a-nievole",
      "name": "Pieve a Nievole",
      "primary": true,
      "skipSearch": false
    }],
    "appalto-via-nova": [{
      "hkey": "c577d92f",
      "slug": "pieve-a-nievole",
      "name": "Pieve a Nievole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f628626d": [{
      "hkey": "c577d92f",
      "slug": "pieve-a-nievole",
      "name": "Pieve a Nievole",
      "primary": true,
      "skipSearch": false
    }],
    "colonna": [{
      "hkey": "c577d92f",
      "slug": "pieve-a-nievole",
      "name": "Pieve a Nievole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "11355b74": [{
      "hkey": "c577d92f",
      "slug": "pieve-a-nievole",
      "name": "Pieve a Nievole",
      "primary": true,
      "skipSearch": false
    }],
    "nievole": [{
      "hkey": "c577d92f",
      "slug": "pieve-a-nievole",
      "name": "Pieve a Nievole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;